export default __webpack_public_path__ + "static/media/home__start2.88909248.jpg";